var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row offset-16"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:{
			'col-md-6 col-lg-4': _vm.client.style === 'modern',
			'col-12': _vm.client.style === 'classic',
		}},[(_vm.client.style === 'classic')?_c('ProductsItemClassic',{attrs:{"item":item,"selectProduct":_vm.selectProduct}}):_c('ProductsItem',{attrs:{"item":item},nativeOn:{"click":function($event){return _vm.selectProduct(item)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }